export default function _setVideoApi(video) {
  video.play = () => {
    if (video.userData.type !== "video") return;
    this.context.videoElements[video.uuid].play();
  };

  video.pause = () => {
    if (video.userData.type !== "video") return;
    this.context.videoElements[video.uuid].pause();
  };

  video.getVideo = () => {
    if (video.userData.type !== "video") return;
    return this.context.videoElements[video.uuid];
  };
}
